// import { FlattenedData } from "../../pages/SystemConfiguration/AccountRole/CreateGroupRole";

import { OptionSelect_V2 } from "../../services/fomartUnit";
import { paserParams } from "../../until";
import axiosClient, { ResponseSuccess, ResponseSuccessTotal } from "../axiosClient";
import { FlattenedData, IAdmin, IDecentralization } from "../configuration/decentralizationApi";
import { IListHistoryLog } from "../Customer_V2/customerApi_V2";
import { IPermission } from "../login/loginApi";
export interface GroupPermission {
  groupIds: number
  groupTitles: string
}
export interface Unit {
  id: number
  title: string
}
export interface permissionGroupsByUnit {
  id: number
  code: string
  title: string
  view: number
  parentId: any
  level: number
  children: permissionGroupsByUnit[]
  groupPermission: GroupPermission
}
export interface unitsByPermissionGroup {
  groupPermissionId: number
  groupPermissionTitle: string
  units: Unit[]
}
export interface listUnitPer {
  unitId: number,
  unitTitle: string
  groupPermissionId: number
}
export interface IAccount {
  id: number
  code: string
  fullname: string
  email: string
  status: number
  unit: string
  groupPermission: string
  region: string,
  businessUnit: string,
  department: string
  nationwide?: string
  permissionGroupsByUnit: permissionGroupsByUnit[]
  listUnitPer: listUnitPer[]
  updatedAt?: string
}

export interface IPermissionCustomer {
  id: number
  username: boolean
  gender: boolean
  phoneHome: boolean
  phoneCompany: boolean
  hobby: boolean
  profession: boolean
  birthday: boolean
  email: boolean
  CCCD: boolean
  province: boolean
  district: boolean
  address: boolean
  taxCode: boolean
  businessName: boolean
  foundingDate: boolean
  businessRelationship: boolean
  actions: number
  statusMarital: boolean
  groupCustomer: boolean
  description: boolean
  image: boolean
  affiliated: boolean
  careStaff: boolean
  sourceCustomer: boolean
  businessFieldId: boolean
  unit: boolean
  code: boolean
}
export interface IAccountDetail {
  code: string
  id: number
  fullname: string
  email: string
  unit: ISL
  image: string
  groupPermission: string[]
  groupPermissionId: number
  region: string
  regionId: number
  department: string
  departmentId: number
  businessUnit: string
  businessUnitId: number
  nationwide: string
  nationwideId: number
  status: boolean
  username: string
  listMenu: IPermission[]
  permissionCustomer: IPermissionCustomer[]
  permissionGroupsByUnit: permissionGroupsByUnit[]
  unitsByPermissionGroup: unitsByPermissionGroup[]
  // listUnitPer: listUnitPer[]
}

export interface ISL {
  id?: number
  title?: string
  code?: string
}

export interface IGroupPermission {
  id: number
  title: string
  description: string
  so_luong: number
  createdAt: string
}
export interface listAdmin {
  adminId: number
  unitId: number[]
}
export interface IGroupPermissionDetail {
  groupPermission: GroupPermission
  listAdmin: listAdmin[]
  menu: IDecentralization[]
}

export interface GroupPermission {
  title: string
  description: string
}

export interface IPermissionCustomer {
  CCCD: boolean
  gender: boolean
  statusMarital: boolean
  businessName: boolean
  phoneHome: boolean
  foundingDate: boolean
  district: boolean
  phoneCompany: boolean
  province: boolean
  hobby: boolean
  address: boolean
  username: boolean
  taxCode: boolean
  businessRelationship: boolean
  profession: boolean
  email: boolean
  actions: number
  birthday: boolean
}

export interface IGroupPermissionCustomerEdit {
  id: number
  groupPermissionId: number
  username: boolean
  gender: boolean
  statusMarital: boolean
  phoneHome: boolean
  phoneCompany: boolean
  hobby: boolean
  profession: boolean
  birthday: boolean
  email: boolean
  CCCD: boolean
  province: boolean
  district: boolean
  address: boolean
  taxCode: boolean
  businessName: boolean
  foundingDate: boolean
  businessRelationship: boolean
  actions: number,
  groupCustomer: boolean
}

export interface FilterListAccount {
  unitId?: number,
  businessUnitId?: number
}
export interface IGroupPermission {
  groupPermissionId: number,
  unitId: number[]
}
export interface IPermissionAdmin {
  adminId: number,
  unitId: number[]
}
export interface IFermissionData {
  recordId: number
  fieldId?: number
  view: boolean
  edit: boolean
}


export interface IGroupPermissionDetail_V2 {
  groupPermission: GroupPermission
  listAdmin: number[]
  listUnit: any[]
  permissionFeature: PermissionFeature[]
  permissionData: PermissionDaum[]
  listCategoryCar: number[]
}

export interface GroupPermission {
  title: string
  description: string
}

export interface PermissionFeature {
  id: number
  name: string
  icon: string
  menuUrl: string
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
   approve:boolean
  children: Children[]
  share: boolean
}

export interface Children {
  id: number
  name: string
  icon: any
  menuUrl?: string
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
   approve:boolean
  children?: Children[]
  share: boolean
}

export interface Children2 {
  id: number
  name: string
  icon: any
  menuUrl: string
  access: boolean
  add: boolean
  edit: boolean
  delete: boolean
  upload: boolean
  download: boolean
}


export interface PermissionDaum {
  id: number
  title: string
  fields: Field[]
}

export interface Field {
  id: number
  fieldCode: string
  fieldLabel: string
  view: boolean
  edit: boolean
}

export interface ISystemLog {
  id: number
  taskId: string
  action: string
  description: any
  moduleId: number
  typeAction: any
  admin: IAdmin
  timestamp:string
  customerId?: number
}
//Danh sách tài khoản người dùng
export const getListUserAccount = async (

  limit?: number, pageNumber?: number, unitId?: number[], businessUnitId?: number,
  search?: string, groupPermissionId?: number, status?: number, groupCustomerId?: number,
  typeEditGroup?: number
) => {
  const path = "groupPermission/listUserAccount"
  const params = {
    limit, pageNumber, unitId, businessUnitId,
    search, groupPermissionId, status, groupCustomerId,
    typeEditGroup
  }
  const result: ResponseSuccessTotal<IAccount[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//	Danh sách log hệ thống
export const getListSystemLog = async (
  limit?: number, pageNumber?: number, search?: string, dateStart?:string,
  dateEnd?:string
) => {
  const path = "groupPermission/listSystemLog"
  const params = {
    limit, pageNumber, search, dateStart,
    dateEnd
  }
  const result: ResponseSuccessTotal<IListHistoryLog[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Danh sách nhóm quyền
export const getListGroupPermission = async (
  limit?: number, pageNumber?: number
) => {
  const path = "groupPermission/getAll"
  const params = {
    limit, pageNumber
  }
  const result: ResponseSuccessTotal<IGroupPermission[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Chi tiết nhóm quyền
export const getInfoGroupPermission = async (
  id: number
) => {
  const path = "groupPermission/detail"
  const params = {
    id
  }
  const result: ResponseSuccess<IGroupPermissionDetail_V2> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thông tin tài khoản người dùng
export const getInfoAccount = async (
  id: number) => {
  const path = "groupPermission/infoUserAccount"
  const params = {
    id
  }
  const result: ResponseSuccess<IAccountDetail> = await axiosClient.get(
    path, { params }
  );
  return result;
};

//Thêm mới nhóm quyền
// export const addGroupPermission = async (
//   title: string, description: string, admin: IPermissionAdmin[], permission: FlattenedData[]
// ) => {
//   const url = `groupPermission/add`;
//   const params = {
//     title, description, admin, permission
//   }
//   const result: ResponseSuccess<{ groupPermissionId: number }> = await axiosClient.post(
//     url, params
//   );
//   return result;
// }

//Thêm mới nhóm quyền
export const addGroupPermission = async (
  title: string, description: string,
  listUnit?: number[], listAdmin?: number[], permissionFeature?: FlattenedData[], permissionData?: IFermissionData[], listCategoryCar?: number[]
) => {
  const url = `groupPermission/add`;
  const params = {
    title, description,
    listUnit, listAdmin, permissionFeature, permissionData, listCategoryCar
  }
  const result: ResponseSuccess<{ groupPermissionId: number }> = await axiosClient.post(
    url, params
  );
  return result;
}

//Chỉnh sửa nhóm quyền
export const editGroupPermission = async (
  id: number, title: string, description: string, listUnit?: number[], listAdmin?: number[], permissionFeature?: FlattenedData[], permissionData?: IFermissionData[], listCategoryCar?: number[]
) => {
  const url = `groupPermission/edit`;
  const params = {
    id, title, description,
    listUnit, listAdmin, permissionFeature, permissionData, listCategoryCar
  }
  const result: ResponseSuccess<{ groupPermissionId: number }> = await axiosClient.put(
    url, params
  );
  return result;
}

//Chỉnh sửa tài khoản người dùng
export const editUserAccount = async (
  id: number, fullname?: string, image?: File | null, email?: string, nationwideId?: number, regionId?: number, unitId?: number, businessUnitId?: number, departmentId?: number, groupPermission?: IGroupPermission[]
) => {
  const url = `groupPermission/editUserAccount`;
  const params = {
    id, fullname, image, email, nationwideId, regionId, unitId, businessUnitId, departmentId, groupPermission
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, params
  );
  return result;
}


//Cập nhật trạng thái hoạt động tài khoản người dùng
export const updateActiveUserAccount = async (
  id: number
) => {
  const url = `groupPermission/activeUserAccount`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}

//Xóa nhóm quyền
export const deleteGroupPermission = async (
  id: number
) => {
  const url = `groupPermission/deleteGroupPermission`;
  const params = {
    id
  }
  const result: ResponseSuccess<[]> = await axiosClient.delete(
    url, { params }
  );
  return result;
}


//quyền khách hàng ---------------------



//Chi tiết quyền khách hàng
export const getInfoPermissionCustomer = async (
  groupPermissionId: number) => {
  const path = "groupPermission/infoPermissionCustomer"
  const params = {
    groupPermissionId
  }
  const result: ResponseSuccess<IGroupPermissionCustomerEdit[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//Chi tiết quyền khách hàng
export const getInfoPermissionCustomer_V2 = async (
  groupPermissionId: number) => {
  const path = "groupPermission/infoPermissionCustomer"
  const params = {
    groupPermissionId
  }
  const result: ResponseSuccess<IPermissionCustomer[]> = await axiosClient.get(
    path, { params }
  );
  return result;
};
//Thêm mới nhóm quyền Chi tiết
export const addPermissionCustomer = async (
  groupPermissionId: number, permissionView: IPermissionCustomer[], permissionEdit: IPermissionCustomer[]
) => {
  const url = `groupPermission/addPermissionCustomer`;
  const params = {
    groupPermissionId, permissionView, permissionEdit
  }
  const result: ResponseSuccess<[]> = await axiosClient.post(
    url, params
  );
  return result;
}

//Chỉnh sửa quyền khách hàng
export const editPermissionCustomer = async (
  groupPermissionId: number, permissionView: any[], permissionEdit: any[]
) => {
  const url = `groupPermission/editPermissionCustomer`;
  const params = {
    groupPermissionId, permissionView, permissionEdit
  }
  const result: ResponseSuccess<[]> = await axiosClient.put(
    url, paserParams(params, undefined)
  );
  return result;
}


